<template>
  <router-link :to="`/curso/${body.slug}`" class="d-block">
    <div class="c-curse">
      <figure class="c-curse__figure">
        <img
          :src="body.thumbnail"
          alt=""
          class="h-100 w-100 of--cover"
        />
      </figure>
      <div class="c-curse__text p-4 h-100 w-100">
        <p>
          {{body.title}}
        </p>
      </div>
      <p v-if="body.level && body.level.label" class="c-curse__lvl">
        {{body.level.label}}
      </p>
      <p class="c-curse__play">
        <span class="d-flex align-items-center justify-content-center">
          Ver el curso
          <Icon icon="akar-icons:play" class="ms-2 fs-30" />
        </span>
      </p>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    body: Object,
  },
};
</script>
